"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SituationsListOverview = _interopRequireDefault(require("./js/SituationsListOverview"));

var _ScenarioFormView = _interopRequireDefault(require("./js/ScenarioFormView"));

var _dictionary = _interopRequireDefault(require("./js/dictionary"));

var _DownloadingAnswersView = _interopRequireDefault(require("./js/DownloadingAnswersView"));

var _reactRouterDom = require("react-router-dom");

var _SavedView = _interopRequireDefault(require("./js/SavedView"));

var _ReviewAnswersView = _interopRequireDefault(require("./js/ReviewAnswersView"));

var _pdfStyles = require("./css/pdf-styles");

var _AudiologistEmailFormView = _interopRequireDefault(require("./js/AudiologistEmailFormView"));

var _AudiologistEmailThankYouView = _interopRequireDefault(require("./js/AudiologistEmailThankYouView"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var PreparationToolComponent = function PreparationToolComponent(_ref) {
  var settings = _ref.settings,
      currentSituations = _ref.currentSituations,
      setCurrentSituations = _ref.setCurrentSituations;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      appData = _useState2[0],
      setappData = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      appointmentTextareaValues = _useState4[0],
      setAppointmentTextareaValues = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      pdfContent = _useState6[0],
      setPdfContent = _useState6[1];

  var history = (0, _reactRouterDom.useHistory)();
  var preparationToolFlexSpot = document.querySelector('.preparation-tool-flex-spot');
  var gradientBackgroundViews = ['/review-answers', '/downloading-answers', '/audiologist-email-form', '/email-sent'];
  var gradientBackgroundViewsMobile = ['/review-answers'];
  (0, _react.useEffect)(function () {
    setappData(getData());
    window.scroll(0, 0);
  }, []);
  (0, _react.useEffect)(function () {
    return history.listen(function () {
      window.scroll(0, 0);

      if (gradientBackgroundViews.includes(history.location.pathname) && window.innerWidth > 767) {
        preparationToolFlexSpot.classList.add('gradient-background');
      } else if (gradientBackgroundViewsMobile.includes(history.location.pathname) && window.innerWidth < 768) {
        preparationToolFlexSpot.classList.add('gradient-background');
      } else {
        preparationToolFlexSpot.classList.remove('gradient-background');
      }
    });
  }, [history]);

  var getData = function getData() {
    var newData = {};
    Object.keys(_dictionary["default"]).map(function (viewData) {
      newData[viewData] = {};
      Object.keys(_dictionary["default"][viewData]).map(function (value) {
        var originalKey = _dictionary["default"][viewData][value];

        if (Array.isArray(originalKey)) {
          newData[viewData][value] = [];
          originalKey.map(function (item) {
            newData[viewData][value].push(settings.preElementItems[item] || settings.postElementItems[item] || null);
          });
        } else {
          newData[viewData][value] = settings.preElementItems[originalKey] || settings.postElementItems[originalKey];
        }
      });
    });
    return newData;
  };

  var printPdf = function printPdf() {
    var settings = {
      defaultTemplateSettings: {
        logoElement: "<div class=\"pdf-logo\" style=\"background-image: url('".concat(document.querySelector('.logo-svg-oticon img').src, "');\"></div>"),
        htmlTemplatePath: "/sitecore/content/Oticon/main/Settings/Mail Templates/Preparation tool/preparation-tool",
        pdfName: appData.features.pdfName ? String(appData.features.pdfName.html.html.trim()) + '.pdf' : 'preparation_visit.pdf',
        languageCode: 'en',
        customStyle: String(_pdfStyles.pdfStylesWithImage),
        footer: '',
        pdfContent: pdfContent,
        header: ''
      }
    };
    Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@demant/feature-pdf-creator'));
    }).then(function (result) {
      return result["default"];
    }).then(function (pdfCreator) {
      pdfCreator(settings, 'save');
      typeof dataLayer !== 'undefined' ? dataLayer.push({
        'event': 'GAevent',
        'eventCategory': 'All Link & Button Clicks',
        'eventAction': 'Download as a pdf file',
        'eventLabel': settings.defaultTemplateSettings.pdfName
      }) : null;
    });
  };

  var deleteScenario = function deleteScenario(e, scenarioIndex, scenario) {
    if (window.confirm(appData.answerOverview.deleteScenarioConfirmation.html.html.trim())) {
      setCurrentSituations(currentSituations.filter(function (scenario) {
        return scenario.scenarioIndex !== scenarioIndex;
      }));
      scenario.isSelected = false;
    }
  };

  var renderScenarioOverviewList = function renderScenarioOverviewList(props) {
    return /*#__PURE__*/_react["default"].createElement(_SituationsListOverview["default"], _extends({}, props, {
      scenarios: settings.elements,
      viewData: appData ? appData : null,
      setCurrentSituations: setCurrentSituations,
      currentSituations: currentSituations
    }));
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "preparation-tool-app"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/downloading-answers",
    render: function render(props) {
      return currentSituations && pdfContent ? /*#__PURE__*/_react["default"].createElement(_DownloadingAnswersView["default"], _extends({}, props, {
        viewData: appData,
        pdfContent: pdfContent,
        printPdf: printPdf
      })) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: "/"
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/email-sent",
    render: function render(props) {
      return pdfContent ? /*#__PURE__*/_react["default"].createElement(_AudiologistEmailThankYouView["default"], _extends({}, props, {
        viewData: appData,
        setCurrentSituations: setCurrentSituations
      })) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: "/"
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/review-answers",
    render: function render(props) {
      return currentSituations && currentSituations.length >= 1 ? /*#__PURE__*/_react["default"].createElement(_ReviewAnswersView["default"], _extends({}, props, {
        viewData: appData,
        currentSituations: currentSituations,
        setCurrentSituations: setCurrentSituations,
        scenarios: settings.elements,
        appointmentTextareaValues: appointmentTextareaValues,
        setAppointmentTextareaValues: setAppointmentTextareaValues,
        setPdfContent: setPdfContent,
        pdfContent: pdfContent,
        printPdf: printPdf,
        deleteScenario: deleteScenario
      })) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: "/"
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/audiologist-email-form",
    render: function render(props) {
      return currentSituations && currentSituations.length >= 1 ? /*#__PURE__*/_react["default"].createElement(_AudiologistEmailFormView["default"], _extends({}, props, {
        viewData: appData,
        pdfContent: pdfContent
      })) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: "/"
      });
    }
  }), settings.elements.map(function (scenario, index) {
    return appData && appData.scenarioFormView.imageLabel && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      exact: true,
      path: "/scenario-".concat(index + 1),
      key: index,
      render: function render(props) {
        return /*#__PURE__*/_react["default"].createElement(_ScenarioFormView["default"], {
          props: props,
          scenario: scenario,
          viewData: appData,
          currentSituations: currentSituations,
          setCurrentSituations: setCurrentSituations
        });
      }
    });
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/saved",
    render: function render(props) {
      return currentSituations ? /*#__PURE__*/_react["default"].createElement(_SavedView["default"], _extends({}, props, {
        viewData: appData,
        currentSituations: currentSituations
      })) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: "/"
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/overview",
    render: function render(props) {
      return renderScenarioOverviewList(props);
    }
  }));
};

var _default = PreparationToolComponent;
exports["default"] = _default;